export const WeekCoverStorageKey = 'week-cover';
